<template>
  <div class="print-notice-page">
    <p>感谢使用我们的证件照应用，为了给您提供更好的使用体验，请认真阅读我们冲印须知，确保您的证件照及时到达您的手中。</p>
    <h3>收件人实名制</h3>
    <p>即日起根据国家相关规定，冲印订单收件人须填写真实姓名，不可使用 ：X小姐、X先生、英文名等，否则快递将拒绝发件。</p>
    <h3>发货时间</h3>
    <p>周一至周六15:00前成功付款的订单当日发货，15:00之后付款的订单次日发货。</p>
    <p>周六15:00后到周一15:00前的订单统一周一发货。</p>
    <p><b>物流信息</b>会在发货当日的21:00左右更新，您可自行在证件照应用的冲印订单中查看。</p>
    <h3>发货快递</h3>
    <p><b>普通快递：</b>普通快递的订单均由四通一达（申通、圆通、中通、汇通、韵达）配送。</p>
    <p><b>加急快递：</b>加急快递的订单由顺丰配送。</p>
    <p>为保障您权益，请在签收快递时确保照片完好无损，如有问题请及时与客服联系并咨询。</p>
    <h3>退款相关</h3>
    <p>因为冲印证件照为定制化特殊商品，且在付款前提供了预览，一经购买，概不退款。</p>
  </div>
</template>

<script>
  export default {
    name: "PrintNotice",
  }
</script>

<style scoped lang="scss">
  .print-notice-page {
    color: #363636;
    background-color: #fff;
    min-height: 100vh;
    padding: 0.12rem;

    h2 {
      font-size: 0.18rem;
      margin: 0.16rem 0;
      text-align: center;
    }

    h3 {
      font-size: 0.16rem;
      border-bottom: 0.01rem dotted #999;
      line-height: 1.5;
      margin: 0.14rem 0;
    }

    p {
      font-size: 0.14rem;
      font-weight: normal;
      line-height: 1.5;
      margin-bottom: 0.08rem;
    }
  }
</style>